export default "__VITE_ASSET__CQlTmd8c__"